// react
import React, { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
// store
import { routes } from "../../store/routes";
import { authService } from "../../store/services/ServiceAuth";
import { isEmailError, isEmpty } from "../../store/services/helpers/validation";
// components
import { Form, Message, Icon } from "semantic-ui-react";
import GoogleSignInButton from "../../components/auth/GoogleSignInButton";
// others
import { useTranslation } from "react-i18next";

// component
function LoginForm(props) {
    const { i18n } = useTranslation();
    // state
    const [email, setEmail] = useState(props.initialEmail || "");
    const [password, setPassword] = useState("");
    const [errorOpen, setErrorOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Neplatné prihlasovacie údaje!");
    const [isProcessing, setIsProcessing] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    let history = useHistory();

    useEffect(() => {
        const googleError = new URLSearchParams(window.location.search).get("google_error");
        if (!googleError) {
            return;
        }
        const googleMessages = {
            cancelled: "Prihlásenie cez Google bolo zrušené.",
            not_configured: "Prihlásenie cez Google nie je nakonfigurované.",
            invalid_state: "Prihlásenie cez Google vypršalo. Skúste to znova.",
            token_invalid: "Google prihlásenie sa nepodarilo overiť.",
            invalid_code: "Prihlásenie cez Google vypršalo. Skúste to znova.",
        };
        setErrorMessage(googleMessages[googleError] || "Prihlásenie cez Google sa nepodarilo. Prihláste sa heslom.");
        setErrorOpen(true);
    }, []);

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsProcessing(true);
        setErrorOpen(false);

        // validate form fields
        let formError = false;
        if (isEmailError(email)) {
            formError = true;
        }

        if (!formError) {
            const loginResult = await authService.login(
                email,
                password,
                props.dispatch,
                history,
                i18n
            );

            if (loginResult === false) {
                setErrorOpen(true);
            } else {
                if (props.onLogin && loginResult.role === "User") {
                    props.onLogin();
                    setIsProcessing(false);
                    return;
                } else if (props.onLogin && loginResult.role !== "User") {
                    props.onLogin("wrong_user");
                    setIsProcessing(false);
                    return;
                }

                if (loginResult.role === "Provider") {
                    history.push(routes.PROFILE);
                    return;
                } if (loginResult.role === "User") {
                    history.push(routes.MY_EVENTS);
                    return;
                } else {
                    history.push(routes.DASHBOARD);
                    return;
                }
            }
        }

        setIsProcessing(false);
    };


    // template
    return (
        <Fragment>
            <style>{`
                .login-form-card {
                    padding: 2rem 1.5rem;
                    max-width: 450px;
                    width: 100%;
                    margin: 0 auto;
                    box-sizing: border-box;
                }
                @media (min-width: 768px) {
                    .login-form-card {
                        padding: 3rem 2.5rem;
                    }
                }
            `}</style>
            <div className="login-form-card" style={{
                background: 'var(--white)',
                borderRadius: '20px',
                border: '1px solid #e0e0e0',
                boxShadow: '0 5px 20px rgba(214, 12, 140, 0.10)',
                position: 'relative',
                width: '100%',
                maxWidth: props.basketRegistration ? '500px' : '450px',
                boxSizing: 'border-box'
            }}>
                <Form onSubmit={handleLogin}>
                    {!props.basketRegistration && (
                    <div style={{
                        textAlign: 'center',
                        marginBottom: '2rem'
                    }}>
                        <Link to={routes.HOME} style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
                            <img
                                src="/images/logos/logo_dark_version.png"
                                width="180"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: '100%',
                                    height: 'auto'
                                }}
                                alt="Activity Point logo"
                            />
                        </Link>
                    </div>
                    )}

                    <Form.Input
                        width={16}
                        size="large"
                        required
                        fluid
                        label="Email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setErrorOpen(false);
                        }}
                        style={{
                            marginBottom: !isEmpty(email) && isEmailError(email) ? "0.35rem" : "1.25rem",
                        }}
                    />
                    {!isEmpty(email) && isEmailError(email) && (
                        <span style={{ display: "block", fontSize: "0.8rem", color: "#db2828", marginBottom: "1.25rem" }}>
                            Zadaj e-mail v tvare meno@domena.sk
                        </span>
                    )}
                    <Form.Input
                        width={16}
                        size="large"
                        required
                        fluid
                        type={showPassword ? "text" : "password"}
                        label="Heslo"
                        placeholder="Heslo"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setErrorOpen(false);
                        }}
                        icon={
                            <Icon
                                style={{ cursor: "pointer", opacity: 0.6 }}
                                name={showPassword ? "eye slash" : "eye"}
                                link
                                onClick={() => setShowPassword && setShowPassword((prev) => !prev)}
                                onMouseDown={e => e.preventDefault()}
                            />
                        }
                        style={{
                            marginBottom: "0.45rem",
                        }}
                    />
                    <div style={{ textAlign: "right", marginBottom: "1.25rem" }}>
                        <Link
                            to={routes.PASSWORD_RESET}
                            style={{
                                color: "var(--primary)",
                                textDecoration: "none",
                                fontSize: "0.9rem",
                            }}
                        >
                            Zabudol si heslo?
                        </Link>
                    </div>

                    {errorOpen && (
                        <Message negative style={{
                            borderRadius: '8px',
                            marginBottom: '1.25rem'
                        }}>
                            {errorMessage}
                        </Message>
                    )}

                    <Form.Button
                        fluid
                        size="big"
                        color="pink"
                        type="submit"
                        loading={isProcessing}
                        disabled={
                            isProcessing ||
                            isEmpty(email) ||
                            isEmpty(password)
                        }
                        style={{
                            marginTop: "1rem",
                            marginBottom: props.passwordOnly ? 0 : "0.75rem",
                        }}
                    >
                        Prihlásiť sa
                    </Form.Button>

                    {!props.passwordOnly && (
                    <>
                    <div style={{ marginBottom: "1.5rem" }}>
                        <GoogleSignInButton nextPath={props.basketRegistration ? routes.BASKET_PAY : ""} />
                    </div>

                    {!props.basketRegistration ? (
                        <div style={{
                            textAlign: "center",
                            paddingTop: '1.5rem',
                            borderTop: '1px solid rgba(214, 12, 140, 0.1)'
                        }}>
                            <p style={{
                                margin: 0,
                                color: 'var(--dark)',
                                fontSize: '0.9rem'
                            }}>
                                Ešte nemáš konto?{' '}
                                <Link
                                    to={routes.REGISTER}
                                    style={{
                                        color: "var(--primary)",
                                        textDecoration: 'none',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Registruj sa tu
                                </Link>
                            </p>
                        </div>
                    ) : (
                        <div style={{
                            textAlign: "center",
                            paddingTop: '1.5rem',
                            borderTop: '1px solid rgba(214, 12, 140, 0.1)'
                        }}>
                            <p style={{ margin: 0, color: 'var(--dark)', fontSize: '0.9rem' }}>
                                Ešte nemáš účet?{' '}
                                <button
                                    type="button"
                                    onClick={props.onRegister}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        color: "var(--primary)",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        fontSize: "0.9rem",
                                    }}
                                >
                                    Zaregistruj sa
                                </button>
                            </p>
                        </div>
                    )}
                    </>
                    )}
                </Form>
            </div>
        </Fragment>
    );
}

export default connect()(LoginForm);
